import React from 'react';
import { useSelector } from 'react-redux';
import { useExperience } from '@unisporkal/experiences';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FeaturedMarketingArea from './FeaturedMarketingArea/FeaturedMarketingArea';
import styles from './Grid.module.scss';

const GridItem = ({
  index,
  targetPath,
  displayUrl,
  contributorDisplayName,
  assetId,
}) => {
  const carouselExperience = useExperience('ReactCreativeCarousel');
  const isFirstTileDoubleSize =
    !carouselExperience.isOfferActive('Carousel') && index === 0;
  return (
    <div
      className={cx(
        styles.gridItemContainer,
        isFirstTileDoubleSize && styles.doubleSize
      )}
      data-testid="grid-item-container"
    >
      <a
        className={styles.gridItemLink}
        href={targetPath}
      >
        <picture
          className={styles.gridItemImage}
          style={{ backgroundImage: `url(${displayUrl})` }}
        />
        <div className={styles.gridItemInfo}>
          <div>{contributorDisplayName}</div>
          <div className={styles.gridItemId}>{assetId}</div>
        </div>
      </a>
    </div>
  );
};

GridItem.propTypes = {
  index: PropTypes.number.isRequired,
  targetPath: PropTypes.string.isRequired,
  displayUrl: PropTypes.string.isRequired,
  contributorDisplayName: PropTypes.string.isRequired,
  assetId: PropTypes.string.isRequired,
};

const Grid = () => {
  const displayAssets = useSelector(
    (state) => state.creativeImageHomeData.displayAssets
  );
  const carouselExperience = useExperience('ReactCreativeCarousel');
  const columnCountConstantClass =
    carouselExperience.isOfferActive('Carousel') && styles.columnCountConstant;

  return (
    <div
      className={cx(styles.container, columnCountConstantClass)}
      data-testid="grid-container"
    >
      {displayAssets.map((asset, index) => (
        <GridItem
          index={index}
          key={asset.asset_id}
          targetPath={asset.target_path}
          displayUrl={asset.display_url}
          contributorDisplayName={asset.contributor_display_name}
          assetId={asset.asset_id}
        />
      ))}
      {!carouselExperience.isOfferActive('Carousel') && (
        <FeaturedMarketingArea />
      )}
    </div>
  );
};

export default Grid;
